import { render, staticRenderFns } from "./BillsReport.vue?vue&type=template&id=4e05025c&"
import script from "./BillsReport.vue?vue&type=script&lang=js&"
export * from "./BillsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports